import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    fetchTeam: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTeamSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchTeamFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchTeam, fetchTeamSuccess, fetchTeamFailure } =
  teamSlice.actions;
export default teamSlice.reducer;
